import { Skeleton } from "@/shared/ui/skeleton";

const PLUGIN_SKELETONS = [
  { id: "plugin-1", nameWidth: "w-24", descriptionWidth: "w-64", tagWidth: "w-14" },
  { id: "plugin-2", nameWidth: "w-28", descriptionWidth: "w-72", tagWidth: "w-16" },
  { id: "plugin-3", nameWidth: "w-20", descriptionWidth: "w-56", tagWidth: "w-14" },
];

export function PluginsPageLoading() {
  return (
    <div className="h-full overflow-y-auto">
      <div className="min-h-full py-6">
        <div className="mb-5 flex items-center justify-between gap-4">
          <div>
            <h1 className="text-xl font-semibold tracking-tight">插件</h1>
            <p className="mt-0.5 text-sm text-muted-foreground">
              管理已安装的插件，或加载本地开发中的插件进行调试
            </p>
          </div>
          <Skeleton className="h-8 w-28 rounded-md" />
        </div>

        <div aria-label="正在加载插件" className="space-y-2" role="status">
          {PLUGIN_SKELETONS.map((plugin) => (
            <div
              className="flex min-h-24 items-center gap-4 rounded-lg bg-background px-4 py-3"
              key={plugin.id}
            >
              <Skeleton className="size-10 shrink-0 rounded-lg" />

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <Skeleton className={`h-4 ${plugin.nameWidth}`} />
                  <Skeleton className="h-3 w-24" />
                </div>
                <Skeleton className={`mt-2 h-3 max-w-full ${plugin.descriptionWidth}`} />
                <Skeleton className={`mt-2 h-5 rounded-md ${plugin.tagWidth}`} />
              </div>

              <div className="flex shrink-0 items-center gap-3">
                <Skeleton className="hidden h-3 w-10 sm:block" />
                <Skeleton className="h-5 w-9 rounded-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
